import { useEffect, useState } from "react";

import { Divider } from "@mui/material";
import Controls from "../../../../components/form/controls/Controls";
import {
  NotifyClearCache,
  NotifyDeployCache,
} from "../../../../components/notify/Notify";
import {
  clearCacheAppVersion,
  deployCacheAppVersion,
  getCacheReleaseAppVersion,
} from "../../../../apis/VersionRelease/appVersion.api";
import useCurrentUserCache from "../../../../hooks/useCurrentUserCache";
import useAuth from "../../../../hooks/useAuth";
import { currentUserHandleCache } from "../../../../utils/helper";
import { allowedDeployCache } from "../../../../constants/role";

const CreateCache = ({ listDataCache, localUser, currentUserCache }) => {
  return (
    <div>
      <p style={{ fontWeight: "bold", marginBottom: "20px" }}>
        {currentUserHandleCache(localUser, currentUserCache)}
        {`vừa tạo ${listDataCache.length} App Version`}
      </p>
      {listDataCache.map((data, index) => (
        <p
          key={data.id}
          style={{ padding: "10px", fontWeight: "bold", color: "#0069A9" }}
        >
          {`${index + 1}. ${data.name}`}
        </p>
      ))}
    </div>
  );
};

const UpdateCache = ({ listDataCache, localUser, currentUserCache }) => {
  return (
    <div>
      <p style={{ fontWeight: "bold", marginBottom: "20px" }}>
        {currentUserHandleCache(localUser, currentUserCache)}
        {`vừa cập nhật ${listDataCache.length} App Version`}
      </p>
      {listDataCache.map((data, index) => (
        <p
          key={data.id}
          style={{ padding: "10px", fontWeight: "bold", color: "#d68102" }}
        >
          {`${index + 1}. ${data.name}`}
        </p>
      ))}
    </div>
  );
};

const ReleaseCache = ({ listDataCache, localUser, currentUserCache }) => {
  return (
    <div>
      <p style={{ fontWeight: "bold", marginBottom: "20px" }}>
        {currentUserHandleCache(localUser, currentUserCache)}
        {`vừa thực hiện release, thứ tự thực hiện`}
      </p>
      <div
        style={{
          margin: "10px 0",
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <span
          style={{
            padding: "10px",
            fontWeight: "bold",
            color: "#fb0b12",
            width: "40%",
          }}
        >
          Mode Release
        </span>
        <span
          style={{
            padding: "10px",
            fontWeight: "bold",
            color: "#fb0b12",
            width: "40%",
          }}
        >
          OS Name
        </span>
        <span
          style={{
            padding: "10px",
            fontWeight: "bold",
            color: "#fb0b12",
            width: "40%",
          }}
        >
          Version
        </span>
      </div>
      {listDataCache.map((data, index) => (
        <div
          key={index}
          style={{
            margin: "10px 0",
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <span
            style={{
              padding: "10px",
              fontWeight: "bold",
              color: "#fb0b12",
              width: "40%",
            }}
          >
            {`${index + 1}. Release ${
              data.isReleaseMass ? "Mass" : "On Group"
            }`}
          </span>
          <span
            style={{
              padding: "10px",
              fontWeight: "bold",
              color: "#fb0b12",
              width: "40%",
            }}
          >
            {`${data.operatingSystem?.name}`}
          </span>
          <span
            style={{
              padding: "10px",
              fontWeight: "bold",
              color: "#fb0b12",
              width: "40%",
            }}
          >
            {`${data.versionCode}`}
          </span>
        </div>
      ))}
    </div>
  );
};

const objectActionCache = {
  Create: CreateCache,
  Update: UpdateCache,
  Release: ReleaseCache,
};

const RenderCache = ({
  listDataCache,
  actionCache,
  localUser,
  currentUserCache,
}) => {
  if (actionCache) {
    return objectActionCache[actionCache]({
      listDataCache,
      localUser,
      currentUserCache,
    });
  }
  return null;
};

const ShowCacheReleaseAppVersion = () => {
  const [listDataCache, setListDataCache] = useState([]);
  const [modelCache, setModelCache] = useState();
  const [actionCache, setActionCache] = useState();

  const { currentUserCache } = useCurrentUserCache();

  const { auth } = useAuth();

  useEffect(() => {
    getCacheReleaseAppVersion((result) => {
      setListDataCache(result.data);
      setModelCache(result.model);
      setActionCache(result.action);
    });
  }, []);

  const handleDeployData = () => {
    NotifyDeployCache(
      "warning",
      "Deploy Data ?",
      "<h5> Tất cả dữ liệu mới sẽ được lưu </h5>",
      (result) => {
        if (result.isConfirmed) {
          deployCacheAppVersion((result) => {
            window.location.reload(true);
          });
        }
      }
    );
  };

  const handleClearData = () => {
    NotifyClearCache(
      "warning",
      "Clear Cache ?",
      "<h5> Tất cả dữ liệu mới sẽ được hủy bỏ </h5>",
      (result) => {
        if (result.isConfirmed) {
          clearCacheAppVersion((result) => {
            window.location.reload(true);
          });
        }
      }
    );
  };

  return (
    <>
      <RenderCache
        listDataCache={listDataCache}
        modelCache={modelCache}
        actionCache={actionCache}
        localUser={auth}
        currentUserCache={currentUserCache}
      />
      <Divider sx={{ width: "100%" }} />
      {allowedDeployCache(
        currentUserCache?.email,
        auth?.email,
        auth?.permissions
      ) ? (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Controls.Button
            sx={{
              width: "150px",
              marginTop: "10px",
            }}
            color="secondary"
            type="button"
            text="Clear Cache"
            onClick={handleClearData}
          />
          <Controls.Button
            sx={{ width: "150px", marginTop: "10px", marginLeft: "10px" }}
            type="button"
            text="Deploy Data"
            onClick={handleDeployData}
          />
        </div>
      ) : null}
    </>
  );
};

export default ShowCacheReleaseAppVersion;
